export enum ETableItem {
  HEAD = 'head',
  ROW = 'row',
}
